import { render, staticRenderFns } from "./DlgAnimalsNew.vue?vue&type=template&id=2c7fa588&scoped=true&"
import script from "./DlgAnimalsNew.vue?vue&type=script&lang=ts&"
export * from "./DlgAnimalsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7fa588",
  null
  
)

export default component.exports